import { useQuery } from "@tanstack/react-query";
import { getCompany } from "services/Company.services";

import type { Company } from "types/Company.type";

export function useCompany() {
  const {
    data: company,
    isLoading,
    error,
  } = useQuery<Company>({
    queryKey: ["company"],
    queryFn: getCompany,
    staleTime: 1000 * 60 * 60, // 1h
  });

  return { company, isLoading, error };
}
